export default "__VITE_ASSET__CIq5WGD5__"